import { ReactElement } from 'react';

import AllocationBreadcrumbs from './components/AllocationBreadcrumbs/AllocationBreadcrumbs';
import { EditClientAllocationProvider } from './context/EditClientAllocationContext';
import EditClientAllocationForm from './EditClientAllocationForm';

const EditClientAllocation = (): ReactElement => (
  <EditClientAllocationProvider>
    <AllocationBreadcrumbs />
    <EditClientAllocationForm />
  </EditClientAllocationProvider>
);

export default EditClientAllocation;
